import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { Resident } from "@graphql/api";

import DocumentsCoverageItem from "./DocumentsCoverageItem";

interface Props {
  isLoading?: boolean;
  resident?: Resident;
}

export default function DocumentsTabContent({ isLoading, resident }: Props) {
  if (!resident?.coverages && isLoading) {
    return <Skeleton width="100%" height={60} variant="rectangular" />;
  }

  if (!resident.coverages.length) {
    return (
      <Typography variant="subtitle1">
        Resident has no documents assigned.
      </Typography>
    );
  }

  return (
    <Stack direction="column">
      {resident?.coverages?.map((coverage) => (
        <DocumentsCoverageItem
          key={coverage.id}
          residentId={resident.id}
          coverage={coverage}
        />
      ))}
    </Stack>
  );
}
